/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RichiesteCausaliCdlApprovazioniDTO
 */
export interface RichiesteCausaliCdlApprovazioniDTO {
    /**
     * 
     * @type {number}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    dataRichiesta?: Date;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    causale?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    daData?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    aData?: Date;
    /**
     * 
     * @type {number}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    ore?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    approvazione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    approvatore?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    idRichiedente?: number;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    richiedente?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    isDeletable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    primoApprovatore?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    secondoApprovatore?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteCausaliCdlApprovazioniDTO
     */
    approvatoIl?: Date | null;
}

/**
 * Check if a given object implements the RichiesteCausaliCdlApprovazioniDTO interface.
 */
export function instanceOfRichiesteCausaliCdlApprovazioniDTO(value: object): value is RichiesteCausaliCdlApprovazioniDTO {
    return true;
}

export function RichiesteCausaliCdlApprovazioniDTOFromJSON(json: any): RichiesteCausaliCdlApprovazioniDTO {
    return RichiesteCausaliCdlApprovazioniDTOFromJSONTyped(json, false);
}

export function RichiesteCausaliCdlApprovazioniDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RichiesteCausaliCdlApprovazioniDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'dataRichiesta': json['dataRichiesta'] == null ? undefined : (new Date(json['dataRichiesta'])),
        'causale': json['causale'] == null ? undefined : json['causale'],
        'daData': json['daData'] == null ? undefined : (new Date(json['daData'])),
        'aData': json['aData'] == null ? undefined : (new Date(json['aData'])),
        'ore': json['ore'] == null ? undefined : json['ore'],
        'approvazione': json['approvazione'] == null ? undefined : json['approvazione'],
        'approvatore': json['approvatore'] == null ? undefined : json['approvatore'],
        'idRichiedente': json['idRichiedente'] == null ? undefined : json['idRichiedente'],
        'richiedente': json['richiedente'] == null ? undefined : json['richiedente'],
        'note': json['note'] == null ? undefined : json['note'],
        'isDeletable': json['isDeletable'] == null ? undefined : json['isDeletable'],
        'primoApprovatore': json['primoApprovatore'] == null ? undefined : json['primoApprovatore'],
        'secondoApprovatore': json['secondoApprovatore'] == null ? undefined : json['secondoApprovatore'],
        'approvatoIl': json['approvatoIl'] == null ? undefined : (new Date(json['approvatoIl'])),
    };
}

export function RichiesteCausaliCdlApprovazioniDTOToJSON(json: any): RichiesteCausaliCdlApprovazioniDTO {
    return RichiesteCausaliCdlApprovazioniDTOToJSONTyped(json, false);
}

export function RichiesteCausaliCdlApprovazioniDTOToJSONTyped(value?: RichiesteCausaliCdlApprovazioniDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dataRichiesta': value['dataRichiesta'] == null ? undefined : ((value['dataRichiesta']).toISOString()),
        'causale': value['causale'],
        'daData': value['daData'] == null ? undefined : ((value['daData']).toISOString()),
        'aData': value['aData'] == null ? undefined : ((value['aData']).toISOString()),
        'ore': value['ore'],
        'approvazione': value['approvazione'],
        'approvatore': value['approvatore'],
        'idRichiedente': value['idRichiedente'],
        'richiedente': value['richiedente'],
        'note': value['note'],
        'isDeletable': value['isDeletable'],
        'primoApprovatore': value['primoApprovatore'],
        'secondoApprovatore': value['secondoApprovatore'],
        'approvatoIl': value['approvatoIl'] == null ? undefined : ((value['approvatoIl'] as any).toISOString()),
    };
}

